<template>
  <div id="app">
    <component :is="currentComponent" @navigate="handleNavigate" :query="queryParam" />
  </div>
</template>

<script>
import IndexView from './components/IndexView.vue';
import SecondView from './components/SecondView.vue';
import LoaderView from './components/LoaderView.vue';

export default {
  name: "SP",
  components: {
    IndexView,
    SecondView,
    LoaderView
  },
  data() {
    return {
      currentComponent: 'LoaderView', // Start with the loader
      queryParam: ''
    }
  },
  mounted() {
    // Get URL parameters when the app loads
    const params = new URLSearchParams(window.location.search);
    this.queryParam = params.get("e") || "";
  },
  methods: {
    handleNavigate(event) {
      this.currentComponent = event.component;
      this.queryParam = event.query || this.queryParam;
    }
  }
};
</script>
